import { Icon, List, ListItem, ListItemIcon, ListItemText, Typography } from '@material-ui/core';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { decodeTokenJsonUser } from '../helpers/jwtDecoder';
import './MenuItems.css';


class MenuItems extends Component {
    render() {
        const { toggleDrawer, loggedUser } = this.props;
        
        if (loggedUser.role === 'COMPANY') {
            return (
                <List style={{ width: 250 }}>
                    <Typography style={{ margin: 0, paddingTop: 10, paddingBottom: 13, textAlign: 'center' }} variant="h6" >InstaJob</Typography>
                    <NavigationLink route="/" icon="assignment" closeDrawer={toggleDrawer}>Golden Demands</NavigationLink>
                </List>
            )
        }

        return (
            <List style={{ width: 250 }}>
                <Typography style={{ margin: 0, paddingTop: 10, paddingBottom: 13, textAlign: 'center' }} variant="h6" >InstaJob</Typography>
                <NavigationLink route="/" icon="home" closeDrawer={toggleDrawer}>Home</NavigationLink>
                <NavigationLink route="/categories" icon="category" closeDrawer={toggleDrawer}>Categories</NavigationLink>
                <NavigationLink route="/questions" icon="live_help" closeDrawer={toggleDrawer}>Questions</NavigationLink>
                <NavigationLink route="/financial/jobcoins" icon="credit_card" closeDrawer={toggleDrawer}>Instajob Plans</NavigationLink>
                <NavigationLink route="/companies" icon="store" closeDrawer={toggleDrawer}>Companies</NavigationLink>
                <NavigationLink route="/email" icon="email" closeDrawer={toggleDrawer}>Email</NavigationLink>
                <NavigationLink route="/users" icon="person" closeDrawer={toggleDrawer}>Users</NavigationLink>
                <NavigationLink route="/marketing-campaigns" icon="local_offer" closeDrawer={toggleDrawer}>Marketing Campaigns</NavigationLink>
                <NavigationLink route="/demand" icon="work" closeDrawer={toggleDrawer}>Demands</NavigationLink>
                <NavigationLink route="/whatsappTable" icon="chat" closeDrawer={toggleDrawer}>WhatsApp</NavigationLink>
                <NavigationLink route="/reviews" icon="chat" closeDrawer={toggleDrawer}>Review</NavigationLink>
            </List>
        );
    }
}

const NavigationLink = ({ route, icon, children, closeDrawer }) => {
    return (
        <Link to={route}>
            <ListItem onClick={closeDrawer} button>
                <ListItemIcon><Icon className="menu-item">{icon}</Icon></ListItemIcon>
                <ListItemText primary={children} />
            </ListItem>
        </Link>
    )
}

const mapStateToProps = ({ authState }) => ({
    loggedUser: decodeTokenJsonUser(authState.loggedUser)
});

export default connect(mapStateToProps)(MenuItems);